import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { AuthForm } from '../../components/AuthForm/AuthForm';
import SignInForm from '../../components/SignInForm/SignInForm';

import signInImg from '../../assets/img/account_login_v2.jpg';
import { rememberSourceFromUrl } from '../../utils/acquisitionSource';

export const LoginPage = () => {
    const { t } = useTranslation();
    const handleLogin = () => console.log('Login succesfull');
    useEffect(() => {
        rememberSourceFromUrl();
    }, []);

    return (
        <AuthForm
            isLogin={true}
            image={signInImg}
            title={t('LogIn.title')}
            subtitle={t('LogIn.subtitle')}>
            <SignInForm onLogin={handleLogin} />
        </AuthForm>
    );
}